const REMEMBER_ME_COOKIE_NAME = 'sso_remember_me';
const REMEMBER_ME_FIELD_MAP = {
    email: 0,
    name: 1,
    isMembership: 2,
    loginType: 3,
    loginSubtype: 4,
};

const hasRememberMeCookie = () => !Odigeo._.isNull(Odigeo.Utils.readCookie(REMEMBER_ME_COOKIE_NAME));

const _getDecodedCookie = () => {
    const cookie = Odigeo.Utils.readCookie(REMEMBER_ME_COOKIE_NAME);
    return cookie ? decodeURIComponent(cookie).split(';') : [];
};

const getRememberMeCookieField = function(field) {
    const fieldIndex = REMEMBER_ME_FIELD_MAP[field];
    const ssoCookie = _getDecodedCookie()[fieldIndex];
    return (ssoCookie && ssoCookie.replace(/[#+]/g, ' ')) || '';
};

const updateRememberMeCookieField = function(field, value) {
    const fieldIndex = REMEMBER_ME_FIELD_MAP[field];
    if (!Odigeo._.isUndefined(fieldIndex)) {
        const ssoCookie = _getDecodedCookie();
        ssoCookie[fieldIndex] = value;
        Odigeo.Utils.createCookie(REMEMBER_ME_COOKIE_NAME, encodeURIComponent(ssoCookie.join(';')));
    }
};

module.exports = {
    hasRememberMeCookie,
    getRememberMeCookieField,
    updateRememberMeCookieField,
};
